import { request } from "./client";
import type { ServiceConfig, ServiceValues } from "./product-service-info";
import { coreServiceFields } from "../components/service-info-defaults";

export interface ServiceSnapshot { values: ServiceValues; config: ServiceConfig }
export interface ServiceSnapshotTemplate { id: string; name: string; snapshot: ServiceSnapshot }
const base = "/admin/products/service-info-templates";
export async function listServiceSnapshotTemplates() {
  return (await request<ServiceSnapshotTemplate[]>(base)).data;
}
export async function getServiceSnapshotTemplate(id: string) {
  return (await request<ServiceSnapshotTemplate>(`${base}/${encodeURIComponent(id)}`)).data;
}
export async function createServiceSnapshotTemplate(input: ServiceSnapshotTemplate) {
  return (await request<ServiceSnapshotTemplate>(base, { method: "POST", body: JSON.stringify(input) })).data;
}
export function copyServiceSnapshot(input: ServiceSnapshot, freshIds = false): ServiceSnapshot {
  const result = JSON.parse(JSON.stringify(input)) as ServiceSnapshot;
  result.values.shippingDescription = null; result.values.invoiceDescription = null; result.config.materialText = null;
  for (const key of ["material", "shippingDescription", "invoiceDescription"] as const) {
    Object.assign(result.config.standard[key], { visible: false, title: null, summary: null });
  }
  // Match the server's title/summary normalization so unknown-result readback
  // compares the persisted payload rather than harmless whitespace differences.
  for (const item of Object.values(result.config.standard)) {
    item.title = item.title?.normalize("NFKC").trim() || null;
    item.summary = item.summary?.trim() ?? null;
  }
  for (const field of coreServiceFields) result.config.standard[field.key].title ||= field.title;
  result.config.custom = result.config.custom.map(item => ({ ...item, title: item.title.trim(), summary: item.summary?.trim() ?? null }));
  if (freshIds) result.config.custom = result.config.custom.map(item => ({ ...item, id: crypto.randomUUID() }));
  return result;
}
